import { render, staticRenderFns } from "./WarningCard.vue?vue&type=template&id=6b5ff04b&scoped=true&"
import script from "./WarningCard.vue?vue&type=script&lang=js&"
export * from "./WarningCard.vue?vue&type=script&lang=js&"
import style0 from "./WarningCard.vue?vue&type=style&index=0&id=6b5ff04b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5ff04b",
  null
  
)

export default component.exports